export default class CustomQueryStringParser {

  constructor() { }

  parse = function (input, _) {
    /*
     * AppAuth-JS library has chosen to not make the second parameter here (useHash)
     * configurable, so we must implement our own parser to ignore it.
     *
     * Source Code: redirect_based_handler.js:105
     * Github Issue: https://github.com/openid/AppAuth-JS/issues/92
     */
      return this.parseQueryString(input.search);
  };

  parseQueryString = function (query) {
    var result = {};
    // if anything starts with ?, # or & remove it
    query = query.trim().replace(/^(\?|#|&)/, '');
    var params = query.split('&');
    for (var i = 0; i < params.length; i += 1) {
      var param = params[i]; // looks something like a=b
      var parts = param.split('=');
      if (parts.length >= 2) {
        var key = decodeURIComponent(parts.shift());
        var value = parts.length > 0 ? parts.join('=') : null;
        if (value) {
          result[key] = decodeURIComponent(value);
        }
      }
    }
    return result;
  };

  stringify = function (input) {
    var encoded = [];
    for (var key in input) {
      if (input.hasOwnProperty(key) && input[key]) {
        encoded.push(encodeURIComponent(key) + "=" + encodeURIComponent(input[key]));
      }
    }
    return encoded.join('&');
  };

}